// @ts-check
import { createElementFromHTML } from "./utils";

/**
 * @param {Object} data
 * @param {string} [data.name]
 * @param {string} [data.explanation]
 * @param {string} data.category1
 * @param {string} data.category2
 * @param {string} data.layer_name
 * @param {string} data.type
 * @param {string} [data.content]
 * @returns {{ contents: string, play: () => Promise<void>, pause: () => Promise<void> }}
 */
export const createPopupContent = (data) => {
  const title = data.name
    ? createElementFromHTML("div", "popup-title", data.name)
    : null;

  const explanation = data.explanation
    ? createElementFromHTML("div", "", data.explanation)
    : null;

  let imgOrVideo = null;
  if (data.content) {
    imgOrVideo = createElementFromHTML(
      data.content.endsWith("jpg") ? "img" : "video"
    );
    imgOrVideo.src = data.content;
    imgOrVideo.dataset.zoomable = "";
    imgOrVideo.muted = true;
    imgOrVideo.autoplay = true;
  }
  const isMp4 = data.content?.endsWith("mp4");

  const play = async () => {
    if (isMp4) {
      imgOrVideo.play();
    }
  };

  const pause = async () => {
    if (isMp4) {
      document.querySelectorAll("video").forEach((el) => {
        // @ts-ignore
        el?.pause();
      });
      imgOrVideo.currentTime = 0;
    }
  };

  const contents = [imgOrVideo, title, explanation]
    .map((el) => el?.outerHTML)
    .join("");

  return { contents, play, pause };
};
